import React from 'react'
import pathToRegexp from 'path-to-regexp'
import { Route, Redirect } from 'react-router'

const RedirectWithParams = ({ exact, from, push, to }) => {
  const pathTo = pathToRegexp.compile(to)
  return (
    <Route exact={exact} path={from} component={({ match: { params } }) => (
      <Redirect to={pathTo(params)} push={push} />
    )} />
  )
}

export default RedirectWithParams



// WEBPACK FOOTER //
// ./src/core/components/redirect-with-params/RedirectWithParams.js